import React from 'react';
import '/assets/css/MainDiv.css';
import Preloader from './PageComponents/Preloader';
import Header from './PageComponents/Header';
import Footer from './PageComponents/Footer';

export default function ChildSafetyStandards() {
  return (
    <div>
      {/* <Preloader/> */}
      <Header />
      <br /><br /><br /><br /><br /><br />

      <div className="mainDiv fadeIn" id="top" data-wow-duration="1s" data-wow-delay="0.5s" style={{ margin: '2%' }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          padding: '20px',
          fontFamily: 'Arial, sans-serif',
          lineHeight: '1.6',
          color: '#333'
        }}>

          {/* Title */}
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1a237e', marginBottom: '10px', lineHeight: '1.2' }}>
              Child Safety Standards
            </h1>
            <p style={{ fontSize: '1rem', color: '#666', marginBottom: '10px' }}>
              VoteVocal (listed on stores as <strong>“Vote Vocal”</strong>)
            </p>
            <p style={{ fontSize: '0.9rem', color: '#888', fontStyle: 'italic' }}>
              Last updated: August 26, 2025
            </p>
          </div>

          {/* 1. Policy Statement */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={h2Style}>1. Policy Statement</h2>
            <p style={pStyle}>
              VoteVocal maintains a <strong>zero-tolerance</strong> policy toward <strong>Child Sexual Abuse and Exploitation (CSAE)</strong> and
              <strong> Child Sexual Abuse Material (CSAM)</strong>. Such content or conduct is strictly prohibited. We comply with applicable child-safety laws.
            </p>
          </section>

          {/* 2. Prohibited Content */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={h2Style}>2. Prohibited Content</h2>
            <p style={pStyle}>The following are prohibited on VoteVocal:</p>
            <ul style={{ paddingLeft: '25px', marginBottom: '15px' }}>
              <li style={liStyle}>CSAM of any kind</li>
              <li style={liStyle}>CSAE or content that exploits, sexualizes, or endangers minors</li>
              <li style={liStyle}>Grooming or solicitation of minors</li>
            </ul>
          </section>

          {/* 3. Reporting Mechanisms */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={h2Style}>3. Reporting Mechanisms</h2>
            <p style={pStyle}>
              Users can report violations via the <strong>in-app “Support” option</strong> in Settings or by email:
              {' '}<a href="mailto:child-safety@votevocal.info" style={aStyle}>child-safety@votevocal.info</a>.
            </p>
          </section>

          {/* 4. Handling of CSAM & Legal Compliance */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={h2Style}>4. Handling of CSAM & Legal Compliance</h2>
            <p style={pStyle}>
              Upon receiving a credible report or detection of CSAM, we act promptly to remove content, restrict accounts, preserve data as required,
              and report to appropriate authorities (including the <strong>National Center for Missing & Exploited Children (NCMEC)</strong> in the U.S.), as required by law.
            </p>
          </section>

          {/* 5. Enforcement */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={h2Style}>5. Enforcement</h2>
            <p style={pStyle}>
              Violations may lead to immediate content removal, account suspension or termination, device/IP blocks where appropriate, and reporting to law enforcement.
            </p>
          </section>

          {/* 6. Designated Child-Safety Contact */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={h2Style}>6. Designated Child-Safety Contact</h2>
            <p style={pStyle}>
              <strong>Child Safety Officer – VoteVocal</strong><br />
              Email: <a href="mailto:child-safety@votevocal.info" style={aStyle}>child-safety@votevocal.info</a>
            </p>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
}

/* inline styles extracted for brevity */
const h2Style = {
  fontSize: '1.8rem',
  fontWeight: 'bold',
  color: '#1a237e',
  marginBottom: '20px',
  borderBottom: '2px solid #4fc3f7',
  paddingBottom: '10px'
};
const pStyle = { fontSize: '1rem', marginBottom: '15px' };
const liStyle = { marginBottom: '8px' };
const aStyle = { color: '#1a237e', textDecoration: 'none' };